// extracted by mini-css-extract-plugin
export default {"wallpaper":"Wallpaper_wallpaper__6++b1","wallpaperImage":"Wallpaper_wallpaperImage__GF1Bx"};